<div class="z-input-wrapper">
  <div
    class="z-input z-select"
    #input
    [style.border-color]="this.isValid ? (ss.colors | async).primary : invalidColor"
    [style.background-color]="(ss.colors | async).mood"
    [style.color]="isAnswered ? (ss.colors | async).primary : (ss.colors | async).text80"
    (click)="dropdown.toggle()"
  >
    @if (selectedOption !== null) {
      {{ selectedOption?.content | translateText: 'choice' : questionData : selectedOption }}
    } @else {
      {{ placeholder }}
    }
    @if (!isAnswered) {
      <mat-icon class="z-arrow-icon" fontSet="zefplayer" [style.color]="(ss.colors | async).button">
        arrow_down
      </mat-icon>
    }
  </div>

  @if (!isValid) {
    <span class="z-error-text">{{ errorText }}</span>
  }

  @if (isAnswered) {
    <mat-icon
      class="z-answered-icon"
      fontSet="zefplayer"
      [style.background-color]="(ss.colors | async).primary"
      [style.color]="(ss.colors | async).primaryParity"
      (click)="resetAnswer()"
    >
      check
    </mat-icon>
  }
</div>

<options-dropdown
  [trackByOption]="trackByOption"
  [filterOptions]="filterOptions"
  [attachedTo]="input"
  [options]="options"
  [selectedOption]="selectedOption"
  [canSearch]="questionData?.type !== Questions.INPUT_NUMERIC"
  (select)="onSelectOption($event)"
  #dropdown="optionsDropdown"
>
  <ng-template let-option>
    {{ option.content | translateText: 'choice' : questionData : option }}
  </ng-template>
</options-dropdown>
